import * as z from 'zod'
const numberRequired = (message: string) => z.number({ required_error: message }).min(1, message)
const stringRequired = (message: string) => z.string({ required_error: message }).min(1, message)
export const orderSchema = z.object({
  orderNumber: z.string(),
  dateReceived: z.union([stringRequired("Please select a date received"), z.date()]),
  requiredByDate: z.union([stringRequired("Required by date is required"), z.date()]),
  submissionMethod: stringRequired("Order received throughis required"),
  customerId: stringRequired("Customer name is required"),
  customerPurchaseOrderNumber: stringRequired("Customer purchase order number is required"),
  deliveryAddress: stringRequired("Delivery address is required"),
  invoiceAddress: stringRequired("Invoice address is required"),
  deliveryInformation: z.string().optional().nullable(),
  orderProducts: z
    .object({
      id: z.string().optional().nullable(),
      qualityId: stringRequired("Please select a quality"),
      finishedReference: z.string().optional().nullable(),
      customerQualityReference: z.string(),
      numberOfRolls: z.number().optional().nullable(),
      totalLengthValue: z.number().optional().nullable(),
      totalLengthUnit: z.number().optional().nullable(),
      pricePerUnitAmount: numberRequired( "Please select a quality to auto fill this field"),
      pricePerUnitCurrency: z.number().optional()
    })
    .array()
})
